module.exports = __webpack_public_path__ + "static/media/checked-checkbox.c5705dd9.svg";